/**
 * PreLogGuestRedirect — DEF-432 bounce for already-signed-in visitors on
 * `/login`, `/register`, and `/forgot-password`.
 *
 * Target is the caller's landing dispatcher (`/` → LandingRedirect) so SSI
 * lands on Properties and company roles on Dashboard — never a hardcoded
 * `/dashboard` (DEF-425).
 */

import { Navigate } from 'react-router-dom';
import { isDevAuth } from '@/lib/dev-auth';
import { DEFAULT_POST_AUTH_PATH } from '@/lib/default-landing';
import { useAuthStore } from '@/stores/auth.store';

/**
 * Redirect an authenticated (non-dev-auth) session off a pre-log page.
 *
 * @param to - Post-auth path. Defaults to `/` so LandingRedirect applies.
 */
export function PreLogGuestRedirect({
  to = DEFAULT_POST_AUTH_PATH,
}: {
  to?: string;
}) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  if (isAuthenticated && !isDevAuth()) {
    return <Navigate to={to} replace />;
  }
  return null;
}
